import { useAtom } from 'jotai';
import { getFloorPriceInfo } from 'pages/AssetsPage/components/Stx20Tab/utils';
import { floorPricesAtom } from 'store/floorPrices';
import { FloorPrice } from 'types/Stx20Types.js';

import useNetwork from './use-network';

export const useFloorPrices = () => {
  const [network] = useNetwork();

  const [floorPrices, setFloorPrices] = useAtom(floorPricesAtom);

  const getFloorPrice = (ticker: string) => {
    const tickerPrice = floorPrices?.find((floorPrice) => floorPrice.ticker === ticker);

    return tickerPrice?.price || 0;
  };

  const loadFloorPrice = async (ticker: string) => {
    const tickerPrice = floorPrices?.find((floorPrice) => floorPrice.ticker === ticker);
    if (tickerPrice) return;
    try {
      const res = await getFloorPriceInfo(ticker, network);
      if (res?.success) {
        setFloorPrices((prevState) => {
          const result = Object.values(
            [...prevState, { ticker: ticker, price: res.data?.medianMinPriceRate || 0 }].reduce(
              (acc, obj) => ({ ...acc, [obj.ticker]: obj }),
              {}
            )
          );

          return result as FloorPrice[];
        });
      }
    } catch (error) {
      setFloorPrices((prevState) => {
        const result = Object.values(
          [...prevState, { ticker: ticker, price: 0 }].reduce(
            (acc, obj) => ({ ...acc, [obj.ticker]: obj }),
            {}
          )
        );

        return result as FloorPrice[];
      });

      console.error('Error fetching floor price:', error);
    }
  };

  return { getFloorPrice, loadFloorPrice };
};
